module.exports = __webpack_public_path__ + "static/img/6325_phase_function_Paper_PointsHejduk_Prediction.28865cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6325_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tpQr
// module chunks = 0